import { Button, ButtonProps } from "@mui/material";
import React from "react";

interface IButtonProps extends ButtonProps {
  text: string | any;
  icon?: React.ReactNode;
  variant?: "text" | "contained" | "outlined";
  textTransform?: "uppercase" | "lowercase" | "capitalize" | "none";
  columnGap?: any;
}

const IconButton: React.FC<IButtonProps> = ({
  text,
  icon,
  onClick,
  className,
  variant = "contained",
  color,
  textTransform = "capitalize",
  columnGap = "2px",
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      className={`${className} tinyBtn`}
      variant={variant}
      style={{
        paddingRight: "10px",
        textTransform,
        columnGap: columnGap,
        fontWeight: variant === "text" ? 700 : "",
      }}
      {...props}
    >
      {icon}
      {text}
    </Button>
  );
};

export default IconButton;
